if (!customElements.get('product-card-information')) {
  customElements.define(
    'product-card-information',
    class ProducCardtInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined; 
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
        this.productUrl = '';
        this.available = true;
        this.that = this;
        this.clearVariantsChoise();

				this.sizePicker = this.querySelector('.card__information-sizes:not(:has(.one_size_label))');
      }

      clearVariantsChoise() {
        let fieldsSets = this.that.querySelectorAll('.product-form__input--pill input[type="radio"]:checked');
        fieldsSets.forEach(elem => {
          elem.checked = false;
        });
      }

      connectedCallback() {
        

        // let checkedInputs = this.querySelectorAll('input[type="radio"]:checked');
        // let fieldsSets = this.querySelectorAll('fieldset');
        
        // if ( checkedInputs.length === fieldsSets.length ) {
          this.initializeProductSwapUtility();
          this.onVariantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.optionValueSelectionChange,
            this.handleOptionValueChange.bind(this)
          );
          
          // this.initQuantityHandlers();
          this.dispatchEvent(new CustomEvent('product-card-information:loaded', { bubbles: true }));
        // }

        // Добавляем инициализацию скрытия цветов
        this.initColorSwatches();

				if (this.sizePicker) {
					// this.sizePicker.addEventListener('click', this.handleSizeClick.bind(this));
				}

        this.dispatchEvent(new CustomEvent('product-card-information:loaded', { bubbles: true }));
        
      }

      initColorSwatches() {
        // Находим fieldset с цветами (уточните селектор, если он другой)
        const swatchFieldset = this.querySelector('.product-form__input--swatch');
        if (!swatchFieldset) return;

        const labels = Array.from(swatchFieldset.querySelectorAll('label'));
        const limit = 3;

        if (labels.length <= limit) return;

        // 1. Скрываем элементы после третьего
        labels.forEach((label, index) => {
          if (index >= limit) {
            label.style.display = 'none';
            label.classList.add('is-hidden-swatch');
          }
        });

        // 2. Создаем кнопку "+"
        const moreBtn = document.createElement('button');
        moreBtn.type = 'base'; // Чтобы не сабмитил форму
        moreBtn.innerText = `+${labels.length - limit}`;
        moreBtn.className = 'swatch-more-btn'; // Добавьте стили в CSS
        
        // Стили прямо в JS для быстроты (лучше вынести в CSS)
        Object.assign(moreBtn.style, {
          cursor: 'pointer',
          border: 'none',
          backgroundImage: 'url(https://cdn.shopify.com/s/files/1/0648/7929/6573/files/plus-icon.svg?v=1776841335)',
          backgroungSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          padding: '0 5px',
          width: '12px',
          height: '12px',
          backgroundColor: 'transparent',
          fontSize: '0'
        });

        // 3. Обработка клика
        moreBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          // Показываем скрытые лейблы
          labels.forEach(label => label.style.display = '');
          // Удаляем кнопку
          moreBtn.remove();
        });

        swatchFieldset.appendChild(moreBtn);
      }


			// Метод для обработки клика
			handleSizeClick(event) {
				// event.currentTarget всегда указывает на элемент, на который мы повесили событие (ваш div .card__information-sizes)
				// даже если кликнули во вложенный элемент
				const button = event.currentTarget;
				
				// Добавляем нужный класс (например, 'active')
				button.classList.toggle('active'); 
				
				// Если нужно просто добавить без возможности убрать:
				// button.classList.add('active');
			}

			

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }


      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl; // f
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct; // f
				// debugger;
        this.productUrl = productUrl;
        // console.log(55, productUrl, selectedOptionValues)

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct  // true / false
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          // const selector = updateFullPage ? "product-card-information[id^='CardProduct']" : 'product-card-information';
          const selector = `#${this.id}`;
          const variant = this.getSelectedVariant(html.querySelector(selector));
          //this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector(`#${this.id}`),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      reloadGallery() {
        let urlProduct = this.productUrl.split('/products/')[1];
        urlProduct = urlProduct.split('?')[0];
        let urlTemplate = '';
        // took product data from 'product.metafields-small-images.liquid' template for 'complementary' products
        if(this.dataset['card'] == 'complementary'){
          urlTemplate = 'metafields-small-images'
        } else {
          urlTemplate = 'metafields';
        }

        fetch(`/products/${urlProduct}?view=${urlTemplate}`)
        .then((response) => response.text())
        .then((responseText) => {
          // let data = JSON.parse(responseText);
          // debugger;
          let cardProduct = document.querySelectorAll(`[data-handle="${urlProduct}"]`);
          let variantId = cardProduct[0]?.querySelector('.product-variant-id').value;
          
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          
          let newGallery = html.querySelector(`[data-variant-id="${variantId}"] .card__media .media`);

          let containerForChange = cardProduct[0]?.querySelector('.card__media .media');
          if ( containerForChange && newGallery) {
            containerForChange.innerHTML = newGallery.innerHTML;
            containerForChange.classList.remove('swiper-initialized');
          }
          window?.sliderProductCard();
        });
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            // document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }




      getSelectedVariant(productInfoNode) {
        let container = this.that;
        let wrapperContainer = container.closest('.product-card-wrapper');
        let dataVariants = wrapperContainer.querySelector('[data-product-full-info]');
        let variants = JSON.parse(dataVariants.innerHTML);
        let fieldsSets = container.querySelectorAll('input[type="radio"]:checked');
        
        if ( fieldsSets.length == 0 ) {
          fieldsSets = container.querySelectorAll('select');
        }
        let filterValues = [];
        fieldsSets.forEach(elem => {
          filterValues.push(elem.value);
        });

        const filteredItems = variants.filter(item => 
          filterValues.every(value => item.options.includes(value))
        );
        // console.log(filteredItems);
        this.available = filteredItems[0].available;
        return filteredItems[0];
        
      }


      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) { // OK
        let  variantSelects = html.querySelector(`#${this.id} variant-selects`);
        // console.log(html);
        variantSelects = null;
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          
          const variant = this.getSelectedVariant(html);

          // console.log(2222, variant)
          // debugger;
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          // this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          let currentId = this.querySelector('.product-variant-id');
          // console.log(currentId);
          if ( currentId && variant.id ) {
            currentId.value = variant.id;
          }
          
          
          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.reloadGallery();


          const hideQuickView = () => {
						// debugger;
            let quick = this.querySelector('.product-card__quick-add');
            let buyButton = this.querySelector('.js-add-to-cart');

            if ( buyButton.closest('.complementary_card_product') ) return false;
            
            let checkedInputs = this.querySelectorAll('input[type="radio"]:checked');
            let fieldsSets = this.querySelectorAll('fieldset');

            if ( ! buyButton ) return false;
					
            if ( !this.available && checkedInputs.length === fieldsSets.length ) {
              // quick.classList.remove('hidden');
              // buyButton.classList.add('hidden');
              let btnQuick = quick.querySelector('[type="submit"]');
              btnQuick.click();
              this.clearVariantsChoise(this);
              checkedInputs[0]?.closest('.card__content')?.querySelector('span.message').classList.add('hidden');
            } else if ( checkedInputs.length === fieldsSets.length ) {
              // quick.classList.add('hidden');
              // buyButton.classList.remove('hidden');
              let btn = buyButton.querySelector('product-form');
							btn.onSubmitHandlerCustom();
              this.clearVariantsChoise();
              checkedInputs[0]?.closest('.card__content')?.querySelector('span.message').classList.add('hidden');
            } else if ( checkedInputs.length === 1 && checkedInputs[0].closest('.product-form__input--swatch') && window.innerWidth > 749 ) {
              checkedInputs[0]?.closest('.card__content')?.querySelector('span.message').classList.remove('hidden');
            }

            const dialog = this.querySelector('dialog');
            if (dialog) {
              dialog.close();
            }

          }

          hideQuickView();

          const updatePrice = () => {
            // document.getElementById('additional-price').innerText = theme.Currency.formatMoney(variant.price);
            // Shopify.formatMoney(cart.total_price).replace('$', 'currencySymbol');
            // this.querySelectorAll('.price-item--regular').innerText = Shopify.formatMoney(variant.price);
            let formatedRegularPrice = Shopify.formatMoney(variant.price);
            let regularPrices = this.querySelectorAll('[data-price-regular]');
            regularPrices.forEach(function(item){
              item.innerText = Shopify.formatMoney(variant.price);
            });
            
            if(variant.compare_at_price){
              let compareAtPrices = this.querySelectorAll('[data-compare-price]');
              compareAtPrices.forEach(function(item){
                item.innerText = Shopify.formatMoney(variant.compare_at_price);
                item.classList.remove('hidden');
              });
            } else {
              let compareAtPrices = this.querySelectorAll('[data-compare-price]');
              compareAtPrices.forEach(function(item){
                item.classList.add('hidden');
              });
            }
          }

          updatePrice();


          this.productForm?.toggleSubmitButton(
            // html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            ! this.available,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }


      updateVariantInputs(variantId) {

        const selectedInput = this.querySelector('input[type="radio"]:checked');
        const isOther = selectedInput && (selectedInput.value === 'אחר' || selectedInput.value === 'Other');
        if (isOther) {
            variantId = '47078516850866'; 
            
            let customAmountInput = this.closest('.product-card-wrapper')?.querySelector('input[type="number"]:not([name="quantity"])');
            
            if (!customAmountInput) {
                 customAmountInput = document.querySelector('.product-form__input--swatch input[type="number"]');
            }

            if (customAmountInput) {
               const formQtyInput = this.querySelector('input[name="quantity"]');
               
               if (formQtyInput) {
                   formQtyInput.value = customAmountInput.value;
                   
                   customAmountInput.addEventListener('input', function() {
                       formQtyInput.value = this.value;
                   });
                   
                   customAmountInput.addEventListener('change', function() {
                       formQtyInput.value = this.value;
                   });
               }
            }
        }

        this.querySelectorAll(
          `#${this.id} #card-product-form-${this.dataset.section}${this.dataset.productId}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }


      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

     

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get pickupAvailability() { 
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector(`#${this.id} variant-selects`);
      }


      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
